import React from 'react';
import styled from 'styled-components';

export function Button(props: React.ComponentProps<typeof StyledButton>) {
  return <StyledButton type="button" id="cart-button" {...props} />;
}

const StyledButton = styled.button<{
  styling: { padding: string; fill: string; strokeWidth: string };
}>`
  display: block;
  position: relative;
  background: 0;
  border: 0;
  width: 100%;
  margin: 0;
  line-height: 0px;
  cursor: pointer;
  padding: ${({ styling }) => styling.padding};

  & > svg > circle,
  & > svg > line {
    stroke: ${({ styling }) => styling.fill};
    stroke-width: ${({ styling }) => styling.strokeWidth};
  }
`;
